import { NgModule } from '@angular/core';
import { LoadingBarComponent } from './loading-bar.component';


@NgModule({
    imports: [
    ],
    exports: [LoadingBarComponent],
    declarations: [LoadingBarComponent],
    providers: [],
})
export class LoadingBarModule { }
